import FormFieldProps from '@App/forms/v2/common/form-field'

const getInputName = (forFieldProps: FormFieldProps): string =>
    forFieldProps.parentObjectName ? forFieldProps.parentObjectName + '.' + forFieldProps.name : forFieldProps.name

export default getInputName
